<script>
import KGauge from "@kagronick/kgauge-vue";

export default {
  extends: KGauge,
  props: {
    chartdata: {},
    options: {},
  },
  watch: {
    chartdata: {
      deep: true,
      handler() {
        // console.log("chartdata updated");
      },
    },
    options: {
      deep: true,
      handler() {
        // console.log("options updated");
      },
    },
  },
};
</script>
